import type { CustomFieldRepository, TagSetRepository, Repository } from "@octopusdeploy/octopus-server-client";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
export function resolveTagSetRepository(repository: Repository): CustomFieldRepository | TagSetRepository {
    const isExtendedTagSetsEnabled = isFeatureToggleEnabled("ExtendedTagSetsFeatureToggle");
    const tagSetRepository = isExtendedTagSetsEnabled ? repository.CustomFields : repository.TagSets;
    return tagSetRepository;
}
